/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestExternalTranscoderConnectionResponse
 */
export interface TestExternalTranscoderConnectionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TestExternalTranscoderConnectionResponse
     */
    ok: boolean;
}

export function TestExternalTranscoderConnectionResponseFromJSON(json: any): TestExternalTranscoderConnectionResponse {
    return TestExternalTranscoderConnectionResponseFromJSONTyped(json, false);
}

export function TestExternalTranscoderConnectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestExternalTranscoderConnectionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': json['ok'],
    };
}

export function TestExternalTranscoderConnectionResponseToJSON(value?: TestExternalTranscoderConnectionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
    };
}


